import React, { FC } from 'react';

interface NewsPromotionCardProps {
  img: string;
  title: string;
  date: string;
  link: string;
}

export const NewsPromotionCard: FC<NewsPromotionCardProps> = ({ img, link, date, title }) => {
  return (
    <a href={link} target="_blank" rel="noreferrer">
      <div className="news-promotion-card card card__primary">
        <img src={img} alt="news" />
        <div className="news-promotion-card__info">
          <article className="news-promotion-card__info__article">{title}</article>
          <p className="news-promotion-card__info__date">{date}</p>
        </div>
      </div>
    </a>
  );
};
